/**
 * @typedef {import('@/types/tracking').ShippingRuleCreatedData} ShippingRuleCreatedData
 */

import Segment from '@/app/users/tracking/segment.js'

const mixpanelOnly = {
  integrations: {
    Mixpanel: true,
    All: false,
  },
}

/**
 * @param {ShippingRuleCreatedData} obj
 */
export default {
  shippingRuleCreatedOrUpdated({
    isNewlyCreatedRule,
    ruleName,
    conditionsProperty,
    conditionsQuantity,
    actionsType,
    actionsQuantity,
    userSubscriptionPlan,
  }) {
    Segment.track(
      `Shipping rules - Rule ${isNewlyCreatedRule ? 'created' : 'updated'}`,
      {
        'Rule name': ruleName,
        'Conditions property': conditionsProperty,
        'Conditions quantity': conditionsQuantity,
        'Actions type': actionsType,
        'Actions quantity': actionsQuantity,
        'User subscription plan': userSubscriptionPlan,
      },
      mixpanelOnly,
    )
  },

  openShippingRuleImportPage() {
    Segment.track('Shipping rules - Open shipping rule import', {}, mixpanelOnly)
  },

  /**
   * @param {{isSuccessful: boolean, numberOfImportedShippingRules: number}} obj
   */
  importShippingRule({ isSuccessful, numberOfImportedShippingRules }) {
    Segment.track(
      'Shipping rules - Import shipping rule',
      { 'Successful': isSuccessful, 'Number of imported shipping rules': numberOfImportedShippingRules },
      mixpanelOnly,
    )
  },

  downloadTemplate() {
    Segment.track('Shipping rules - Download template', {}, mixpanelOnly)
  },

  downloadCheatlist() {
    Segment.track('Shipping rules - Download cheatlist', {}, mixpanelOnly)
  },

  openHelpCenter(source) {
    Segment.track(
      'Shipping rules - Open help center',
      {
        source: source,
      },
      mixpanelOnly,
    )
  },

  openAcademy(source) {
    Segment.track(
      'Shipping rules - Open academy',
      {
        source: source,
      },
      mixpanelOnly,
    )
  },
}
